import React, { useRef, useState, useEffect } from "react";
import BlogCard from "../components/BlogCard";
import "../Styles/Blog.css";

const BLOGS_URL =
  "https://raw.githubusercontent.com/DhotradSunnyDentalandOrthodonticClinics/website-blogs/main/blogs.json";

const BlogSection = () => {
  const scrollRef = useRef(null);
  const [blogs, setBlogs] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchBlogs = async () => {
    try {
      // cache-buster (safe, no API, no 403)
      const res = await fetch(`${BLOGS_URL}?v=${Date.now()}`, {
        cache: "no-store",
      });

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      const data = await res.json();
      console.log("BLOGS FETCHED:", data);

      setBlogs(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Failed to fetch blogs:", err);
      setBlogs([]);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const filteredBlogs = blogs.filter((b) => {
    const t = b.title || "";
    const d = b.description || "";
    const a = b.author || "";

    return (
      t.toLowerCase().includes(searchTerm.toLowerCase()) ||
      d.toLowerCase().includes(searchTerm.toLowerCase()) ||
      a.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  return (
    <div className="blogs-container">
      <h2 className="blogs-title">Blogs</h2>

      <input
        className="blog-search"
        type="text"
        placeholder="Search blogs..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <div
        className={`blogs-scroll ${
          filteredBlogs.length < 4 ? "center-blogs" : ""
        }`}
        ref={scrollRef}
      >
        {filteredBlogs.length ? (
          filteredBlogs.map((blog) => <BlogCard key={blog.id} blog={blog} />)
        ) : (
          <p className="no-results">No blogs found.</p>
        )}
      </div>
    </div>
  );
};

export default BlogSection;
